import { DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, getDateFormat, getFullName } from '../../../../../Apis/functions';
import RowResumeText from '../../../../../components/RowResumeText';
import React from 'react';
import DividerWithText from '../../../../../components/DividerWithText';
import { useTranslation } from 'react-i18next';
import { getUserTypeCounts } from '../Model/Models';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ReservationSummary = (
    {
        eventDetail, selectedHost, usersSelected, userData
    }
) => {
    const { t } = useTranslation();
    const counts = getUserTypeCounts(usersSelected);

    return (
        <>
            <DividerWithText title={t("details")} />

            <div className="row d-flex justify-content-center mb-3">
                <div className="col-12 col-md-8">
                    <RowResumeText title={t("name")} value={eventDetail?.name || EMPTY_VALUES.DEFAULT} />
                </div>
            </div>

            <div className="row d-flex justify-content-center mb-3">
                <div className="col-12 col-md-8">
                    <RowResumeText
                        title={t("host")}
                        value={selectedHost?.length > 0 ?
                            getFullName(selectedHost[0]?.name, selectedHost[0]?.firstLastName, selectedHost[0]?.secondLastName) :
                            (userData?.fullName || EMPTY_VALUES.DEFAULT)}
                    />
                </div>
            </div>

            <div className="row d-flex justify-content-center g-3 mb-3">
                <div className="col-md-4">
                    <RowResumeText
                        title={t("email")}
                        value={selectedHost?.length > 0 ? selectedHost[0]?.email : (userData?.email || EMPTY_VALUES.DEFAULT)}
                    />
                </div>
                <div className="col-md-4">
                    <RowResumeText
                        title={t("phone_number")}
                        value={selectedHost?.length > 0 ? selectedHost[0]?.phoneNumber : (userData?.phoneNumber || EMPTY_VALUES.DEFAULT)}
                    />
                </div>
            </div>

            <DividerWithText title={t("schedule_location")} />

            <div className="row d-flex justify-content-center mb-3">
                <div className="col-12 col-md-8">
                    <RowResumeText title={t("common_area")} value={eventDetail?.zoneSelected?.zoneName || EMPTY_VALUES.DEFAULT} />
                </div>
            </div>

            <div className="row d-flex justify-content-center mb-3">
                <div className="col-12 col-md-8 ">
                    <RowResumeText title={t("date")} value={eventDetail?.dateSelected ? getDateFormat(eventDetail?.dateSelected, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth) : EMPTY_VALUES.DEFAULT} />
                </div>
            </div>

            <div className="row d-flex justify-content-center g-3 mb-3">
                <div className="col-md-4">
                    <RowResumeText title={t("from")} value={eventDetail?.bookingSelected?.from || EMPTY_VALUES.DEFAULT} />
                </div>
                <div className="col-md-4">
                    <RowResumeText title={t("to")} value={eventDetail?.bookingSelected?.to || EMPTY_VALUES.DEFAULT} />
                </div>
            </div>

            <div className="row d-flex justify-content-center mb-3">
                <div className="col-12 col-md-8">
                    <RowResumeText title={t("duration")} value={`${eventDetail?.bookingSelected?.duration} ${t("minutes")}`} />
                </div>
            </div>

            <DividerWithText title={t("attendees_types")} />

            <div className="row d-flex justify-content-center g-3 mb-3">
                <div className="col-md-4">
                    <RowResumeText title={t("employees")} value={counts.EMPLOYEE + ""} />
                </div>
                <div className="col-md-4">
                    <RowResumeText title={t("contractors")} value={counts.CONTRACTOR_IN_CHARGE + ""} />
                </div>
            </div>

            <div className="row d-flex justify-content-center g-3 mb-3">
                <div className="col-md-4">
                    <RowResumeText title={t("suppliers")} value={counts.SUPPLIER_IN_CHARGE + ""} />
                </div>
                <div className="col-md-4">
                    <RowResumeText title={t("visitors")} value={counts.VISITOR + ""} />
                </div>
            </div>
        </>
    );
};

export default ReservationSummary;
